import { Component, OnInit, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { finalize, map, takeUntil } from 'rxjs/operators';

import { PageNames } from 'src/app/configs/page-names.enum';
import { ResellersWithPaginationByUserIdDto } from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { MenuBtnComponent } from 'src/app/shared/global/menu-btn/menu-btn.component';
import { ResellerDto } from '../../../core/api/models/reseller-dto';
import { ResellersService } from '../../../core/api/services/resellers.service';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';
import { PaginatedListOfResellerWithPaginationDto } from './../../../core/api/models/paginated-list-of-reseller-with-pagination-dto';
import { ResellerWithPaginationDto } from './../../../core/api/models/reseller-with-pagination-dto';
import { FormPageConfig } from './../../../core/models/form-page-config.model';
import { ResellersFormComponent } from './resellers-form/resellers-form.component';

@Component({
  selector: 'app-resellers',
  templateUrl: './resellers.component.html',
  imports: [BaseIndexModule, MenuBtnComponent, ResellersFormComponent],
})
export class ResellersComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  pageName = PageNames.resellers;

  /* Binding service endpoints */
  protected currentService = inject(ResellersService);
  paginationApiMethodName: string =
    this.currentService.resellersGetResellersWithPagination.name;
  createGetApiMethodName: string = this.currentService.resellersCreateGet.name;
  deleteApiMethodName: string = this.currentService.resellersDelete.name;
  auditApiMethodName: string =
    this.currentService.resellersGetResellersAudit.name;
  /* Binding service endpoints */

  modelWithPagination$: Observable<PaginatedListOfResellerWithPaginationDto>;
  items$: Observable<Array<ResellerWithPaginationDto>>;
  formPageConfig: FormPageConfig<ResellerDto> = {};

  resellersOrganizations$: Observable<
    Array<ResellersWithPaginationByUserIdDto>
  >;

  resellerUserIdSelected: any;
  isShowResellerOrganizations: boolean = false;

  //#endregion

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  configTableColumns() {
    this.tableColumns = [
      {
        title: `${this.tableVocabs}reseller`,
        name: 'userName',
        hasSearch: true,
      },
      {
        title: this.localizer.organization,
        name: 'organizationName',
        hasSearch: true,
      },
      {
        title: `${this.tableVocabs}panelPercent`,
        name: 'panelPercent',
        hasSearch: true,
        type: 'number',
      },
      {
        title: `${this.tableVocabs}pricePerSms`,
        name: 'pricePerSms',
        hasSearch: true,
        type: 'number',
        needCurrency: true,
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
      },
      {
        title: this.localizer.expireDate,
        name: 'expireDate',
        hasSearch: true,
        type: 'date',
      },
    ];
  }

  //#region Api

  //Get ById
  baseGetByIdApi(id: number): void {
    this.pageConfig.loading = true;

    this.formPageConfig.editId = id;

    this.currentService
      .resellersUpdateGet({ Id: id })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseGetByIdObserver);
  }

  getResellersWithPaginationByUserIdApi(userId: any) {
    this.unSubs();
    this.pageConfig.loading = true;

    this.currentService
      .resellersGetResellersWithPaginationByUserId({
        body: { ...this.getBaseModelWithPaginationParams(), userId: userId },
      })
      .pipe(
        map((itemsWithPagination) => itemsWithPagination.data?.items),
        finalize(() => (this.pageConfig.loading = false)),
        takeUntil(this.onDestroy$)
      )
      .subscribe((items) => {
        if (items) {
          try {
            this.resellersOrganizations$ = of(items);
            this.isShowResellerOrganizations = true;
          } catch (error) {
            this.loggerService.logError(
              this.tagName,
              error,
              EventTypes.systemManagement
            );
          }
        }
      });
  }

  //#endregion

  onShowResellerOrganizations(userId) {
    this.resellerUserIdSelected = userId;
    this.getResellersWithPaginationByUserIdApi(userId);
  }
}
